import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const RoundedStarFillIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 16 16"
    >
      <path
        d="M15.1087 6.21094C14.974 5.79654 14.623 5.49348 14.194 5.42061L10.6888 4.82101L9.03508 1.67288L9.03575 1.67254C8.83262 1.28648 8.43615 1.04688 7.99995 1.04688H7.99928C7.56342 1.04721 7.16695 1.28714 6.96448 1.67288L5.31148 4.82101L1.80629 5.42061C1.37629 5.49421 1.02569 5.79754 0.890952 6.21228C0.756485 6.62701 0.861952 7.07848 1.16635 7.39068L3.64975 9.93561L3.13642 13.4545C3.07362 13.8861 3.25362 14.3139 3.60682 14.5697C3.81095 14.7182 4.05115 14.7937 4.29335 14.7937C4.47009 14.7937 4.64749 14.7533 4.81255 14.6719L8.00002 13.0964L11.1875 14.6713C11.5794 14.8653 12.0403 14.8269 12.3932 14.5697C12.7461 14.3132 12.9264 13.8861 12.8633 13.4545L12.3509 9.93561L14.834 7.39034C15.1386 7.07781 15.2441 6.62594 15.1087 6.21094Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

RoundedStarFillIcon.displayName = 'RoundedStarFillIcon';
